import { NumberField, OrmModel, StringField, AttrField, HasManyByField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import {
  ScheduledRecipientTypes,
  type ScheduledRequestStatus,
  type ScheduledType,
} from '@/components/views/scheduled/types'
import Label from '@/data/models/domain/Label'
import { TmArrayStringField } from '@/data/utils/types'

@OrmModel(modelNames.SCHEDULED_SHORT_MESSAGE)
export default class ScheduledShortMessage extends BaseModel {
  @StringField(null)
  public title: string | null

  @StringField(null)
  public avatar: string | null

  @StringField()
  public contactName: string

  @NumberField()
  public recipientsCount: number

  @AttrField([])
  public recipientTypes: ScheduledRecipientTypes[]

  @StringField()
  public type: string

  @StringField()
  public message: string

  @StringField(null)
  public lastSent: string | null

  @StringField(null)
  public nextSend: string | null

  @StringField()
  public firstOccurrence: string

  @StringField()
  public rrule: string

  @StringField()
  public requestStatus: ScheduledRequestStatus

  @StringField()
  public status: ScheduledType

  @StringField()
  public createdAt: string

  @AttrField()
  public entityId: number | null

  @TmArrayStringField()
  public labelIds: string[]

  @HasManyByField(Label, 'labelIds')
  public labels: Label[]

  public get isBulk() {
    return (
      this.recipientsCount > 1 ||
      this.recipientTypes.some((type) =>
        [ScheduledRecipientTypes.GROUPS, ScheduledRecipientTypes.FILTERED_VIEWS].includes(type),
      )
    )
  }
}
